<template name="ModalSlide">
  <transition name="slide">
    <div
      class="slidein "
      v-bind:class="show === false ? 'clear-bg' : 'show-bg overflow-hidden'"
      v-show="show"
      @click.self="backgroundPressed()"
    >
      <div class="side sm:w-full" v-bind:class="modalWidth" v-on:click.prevent>
        <div
          class="
            py-2
            flex
            justify-between
            items-center
            border-b border-gray-200
            pl-6
            bg-gray-200
          "
          :class="headCss"
        >
          <div class="pl-2 flex content-center">
            <div class="text-lg pr-2 text-base text-purple-700">
              <slot name="header-icon"> </slot>
            </div>

            <div class="font-bold text-base pl-2">
              <slot name="header-title"></slot>
            </div>
          </div>

          <div class="w-32 pr-6 text-right">
            <div class="flex items-center float-right">
              <div class="pr-6">
                <slot name="header-action"></slot>
              </div>
              <button class="text-2xl  focus:outline-none" @click="closeWindow()">
                <span class="text-base font-semibold" v-if="!closeIcon"> Close</span>
                <i v-else
                  class="fas fa-times text-lg pl-4 hover:opacity-75"
                  title="Close"
                ></i>
              </button>
            </div>
          </div>
        </div>
        <div class="p-3 pt-4 text-sm h-screen overflow-y-auto slide-content">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>
  
  <script>
const props = {
  show: {
    type: Boolean,
    default: false,
  },
  cssWidth: {
    type: String,
    default: "md:w-5/12"
  },
  closeIcon: {
    type: Boolean,
    default: true,
  },
  headCss: {
    type: String,
     default: ""
  }
};
export default {
  name: "ModalSlide",
  props,
  computed: {
    modalWidth() {
      return  this.cssWidth
    }
  },
  data() {
    return {
      isShowing: this.show,
    };
  },
  methods: {
    closeWindow() {
      this.isShowing = false;
      this.$emit("closeModal");
    },
    backgroundPressed() {
      this.closeWindow();
    },
  },
};
</script>
  
  <style scoped>
.slidein {
  min-width: 100%;
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0);
  height: 100%;
}

.slidein.show-bg {
  -webkit-animation: fadein 4.3s forwards;
  -moz-animation: fadein 4.3s forwards;
  animation: fadein 4.3s forwards;
}

.slidein.clear-bg {
  background-color: rgba(0, 0, 0, 0) !important;
}

@keyframes fadein {
  0% {
    background-color: rgba(0, 0, 0, 0);
  }
  10% {
    background-color: rgba(0, 0, 0, 0);
  }
  100% {
    background-color: rgba(0, 0, 0, 0.2);
  }
}

.slide-enter-active {
  transition: all 0.75s ease-out;
}

.slide-leave-active {
  transition: all 0.35s ease-out;
}
.slide-enter-to {
  right: 0;
}
.slide-enter-from {
  right: -100%;
}
.slide-leave-to {
  right: -100%;
}
.slide-leave-from {
  right: 0;
}

.side {
  z-index: 101;
  position: absolute;
  top: 0;
  right: 0;
  background: #fff;
  height: 100%;
  opacity: 1 !important;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.3s ease;
}

.modal-mask-bg {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
 }

.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
</style>
  